var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.landing && !_vm.landing.useHomeVodModule)?_c('Background'):_vm._e(),_c('div',[(_vm.landing && _vm.landing.useHomeVodModule)?_c('home-vod'):(_vm.landing && _vm.landing.customHtml)?_c(_vm.dynamicComponent,{tag:"component"}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }